import DropDownMenu from '~components/DropDownMenu'
import { Props } from './interfaces'
import * as Styled from './styled'
import useActionMenu from './hooks/useActionMenu'

function ActionMenu({ actions, row, comparisonProp, comparisonValue, width }: Props) {
  const { handleActionsToggle, isActionsOpened } = useActionMenu()

  return (
    <Styled.Wrapper>
      <Styled.Icon name="kebab-vertical" onClick={handleActionsToggle} />
      <DropDownMenu
        width={width}
        options={actions}
        isOpened={isActionsOpened}
        row={row}
        onClickOutside={handleActionsToggle}
        comparisonProp={comparisonProp}
        comparisonValue={comparisonValue}
      />
    </Styled.Wrapper>
  )
}

export default ActionMenu
